import { render } from "./TSMItemPage.vue?vue&type=template&id=4fb9e86a&scoped=true"
import script from "./TSMItemPage.vue?vue&type=script&lang=js"
export * from "./TSMItemPage.vue?vue&type=script&lang=js"

import "./TSMItemPage.vue?vue&type=style&index=0&id=4fb9e86a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb9e86a"]])

export default __exports__